import { css } from '@emotion/core'
import { spacing, measures, colors, font } from 'styles/variables'

const { unit } = measures

export const container = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 400px;
`

// Reused and adapted from aboutUs/styles.js
export const menuContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: ${spacing(1.25)};
  width: 100%;
  box-sizing: border-box;
  padding: ${spacing(2)};
`

export const imageContainer = css`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: ${spacing(3)};
  position: relative;
`

export const menuImage = css`
  width: 100%;
  max-width: 400px;
  height: auto;
  object-fit: contain;
  border-radius: ${unit * 1.5}px;
`

export const imageTextOverlay = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: left;
  z-index: 2;
  width: 90%;
  max-width: 360px;
`

export const overlayTitle = css`
  margin: 0;
  margin-bottom: ${spacing(0.5)};
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  font-style: italic;
`

export const overlaySubtitle = css`
  margin: 0;
  margin-bottom: ${spacing(2)};
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  font-style: italic;
`

export const spacer = css`
  height: ${spacing(6)};
  width: 100%;
`

export const overlayDescription = css`
  margin: 0;
  line-height: 1.4;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
`

export const personalizeButton = css`
  background: linear-gradient(135deg, #8B5CF6, #6366F1);
  border: none;
  border-radius: 25px;
  padding: ${spacing(2, 4)};
  margin-top: ${spacing(4)};
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(139, 92, 246, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
`

export const menuItem = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  width: 100%;
  padding: ${spacing(2.5)};
  background-color: ${colors.grays.gray8};
  color: ${colors.white100};
  border-radius: ${unit * 1.5}px;
  box-sizing: border-box;
  transition: all 0.3s ease;
  font-family: ${font.family};
  border: none;
  cursor: pointer;
  
  &:hover {
    background-color: ${colors.grays.gray7};
  }
  
  &:active {
    background-color: ${colors.grays.gray6};
  }
`



export const chevronIcon = css`
  color: ${colors.white60};
  font-size: 14px;
`

export const headerWithBack = css`
  position: relative;
  display: flex;
  align-items: flex-start;
  margin-bottom: ${spacing(2)};
  padding-top: ${spacing(0.5)};
`

export const backArrow = css`
  color: #ffffff;
  font-size: 22px;
  cursor: pointer;
  user-select: none;
  margin-right: ${spacing(2)};
  margin-top: -${spacing(0.25)};
  transition: all 0.3s ease;
  
  &:hover {
    color: ${colors.white80};
  }
`

// Reused and adapted from privacyPolicy/styles.js
export const contentSection = css`
  display: flex;
  flex-direction: column;
  padding: ${spacing(2)};
  width: 100%;
  box-sizing: border-box;
  position: relative;
`

export const scrollableContainer = css`
  /* Remove the nested scrolling since the parent tabContent already handles it */
  /* Just ensure proper spacing and let the page scroll naturally */
  padding-bottom: ${spacing(4)};
`

export const textContainer = css`
  display: flex;
  flex-direction: column;
  gap: ${2 * unit}px;
  text-align: left;

  > * {
    line-height: ${3 * unit}px;
  }
`

export const linkCustom = css`
  text-decoration: none;
  color: #6d61ff;
  
  &:hover {
    color: #8b7dff;
  }
`

export const linkContainer = css`
  margin: ${spacing(2, 0)};
`

export const externalLink = css`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.grays.gray8};
  color: ${colors.white100};
  text-decoration: none;
  padding: ${spacing(2)};
  border-radius: ${unit * 1.5}px;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: ${colors.grays.gray7};
    color: #6d61ff;
  }
`

// Contact section specific styles
export const contactMethod = css`
  display: flex;
  align-items: flex-start;
  padding: ${spacing(2, 0)};
  border-bottom: 1px solid ${colors.grays.gray8};
  
  &:last-child {
    border-bottom: none;
  }
`

export const businessHours = css`
  background-color: ${colors.grays.gray9};
  padding: ${spacing(2)};
  border-radius: ${unit * 1.5}px;
  margin-top: ${spacing(2)};
  
  > :first-child {
    margin-bottom: ${spacing(1)};
  }
`

// Modal styles
export const modalOverlay = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: ${spacing(4)};
  box-sizing: border-box;
`

export const modalContainer = css`
  background-color: ${colors.grays.gray8};
  border-radius: ${unit * 3}px;
  width: 100%;
  max-width: 400px;
  position: relative;
  animation: slideUp 0.3s ease-out;
  
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const closeButton = css`
  position: absolute;
  top: ${spacing(3)};
  right: ${spacing(3)};
  background: transparent;
  border: none;
  color: ${colors.white60};
  cursor: pointer;
  font-size: 18px;
  z-index: 10001;
  
  &:hover {
    color: ${colors.white100};
  }
`

export const modalContent = css`
  padding: ${spacing(6)};
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};
`

export const modalTitle = css`
  margin: 0;
  color: ${colors.white100};
  line-height: 1.2;
`

export const modalDescription = css`
  margin: 0;
  color: ${colors.white80};
  line-height: 1.4;
`

export const inputContainer = css`
  position: relative;
  margin: ${spacing(2, 0)};
`

export const textInput = css`
  width: 100%;
  min-height: 80px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid ${colors.white40};
  color: ${colors.white100};
  font-family: ${font.family};
  font-size: 14px;
  padding: 0;
  padding-top: 65px;
  padding-bottom: 0;
  resize: none;
  outline: none;
  box-sizing: border-box;
  line-height: 1;
  
  &::placeholder {
    color: ${colors.white40};
  }
  
  &:focus {
    border-bottom-color: ${colors.white60};
  }
`

export const characterCounter = css`
  position: absolute;
  bottom: ${spacing(1)};
  right: 0;
`

export const counterText = css`
  color: ${colors.white40};
`

export const sendButton = css`
  background-color: #5AC98A;
  color: #000000;
  border: none;
  border-radius: ${unit * 4}px;
  padding: ${spacing(3, 6)};
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: stretch;
  
  &:hover {
    background-color: #4BB079;
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
`

export const sendButtonText = css`
  color: #000000 !important;
`

export const sendButtonDisabled = css`
  background-color: #3D7C47 !important;
  color: #000000 !important;
  cursor: not-allowed !important;
  opacity: 0.6;
  
  &:hover {
    background-color: #3D7C47 !important;
    transform: none !important;
  }
  
  &:active {
    transform: none !important;
  }
  
  * {
    color: #000000 !important;
  }
` 